import Cookies from 'js-cookie';

const initialState = {
  is: {},
  en: {},
  lang: 'is',
  loaded: false
};

const setBrowserLang = lang => {
  if (lang === 'is') {
    Cookies.set('userCulture', 'c=is-IS|uic=is');
  }
  if (lang === 'en') {
    Cookies.set('userCulture', 'c=en-US|uic=en');
  }
};

export const addLocale = (lang, localeObj) => {
  return {
    type: 'ADD_LOCALE_STRINGS',
    lang,
    localeObj
  };
};

export const setLanguage = lang => {
  return {
    type: 'SET_LANGUAGE',
    lang
  };
};

export const localeReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'ADD_LOCALE_STRINGS': {
      let loaded = state.loaded;
      if (state.lang === action.lang) {
        loaded = true;
      }
      return { ...state, [action.lang]: action.localeObj, loaded: loaded };
    }

    case 'SET_LANGUAGE': {
      if (action.lang !== state.lang) {
        setBrowserLang(action.lang);
      }
      return { ...state, lang: action.lang };
    }

    default:
      return state;
  }
};

export default localeReducer;



// WEBPACK FOOTER //
// ./src/common/jsx/locale/ducks.js